export async function dismissConversationNotifications(conversationId: string): Promise<void> {
  if (typeof navigator === 'undefined' || !('serviceWorker' in navigator)) return;
  if (!conversationId) return;

  try {
    const registration = await navigator.serviceWorker.getRegistration(
      '/firebase-cloud-messaging-push-scope'
    );
    if (!registration) return;

    const tag = `msg-${conversationId}`;
    const notifications = await registration.getNotifications({ tag });
    notifications.forEach((n) => n.close());
  } catch {
  }
}

export async function dismissNotificationsByType(type: string): Promise<void> {
  if (typeof navigator === 'undefined' || !('serviceWorker' in navigator)) return;
  if (!type) return;

  try {
    const registration = await navigator.serviceWorker.getRegistration(
      '/firebase-cloud-messaging-push-scope'
    );
    if (!registration) return;

    const tag = String(type).toUpperCase();
    const notifications = await registration.getNotifications({ tag });
    notifications.forEach((n) => n.close());
  } catch {
  }
}
